import React, { FC } from "react";
import FullCalendar from "@fullcalendar/react";
import { DatesSetArg, ViewMountArg } from "@fullcalendar/core";
import { TFunction } from "i18next";
import {
  CALENDAR_PLUGINS,
  getCalendarToolbarOptions,
} from "../calendarToolbarConfig";
import { CalendarPeriod } from "../calendarPeriod";

interface TaskCalendarToolbarProps {
  t: TFunction;
  currentPeriod: CalendarPeriod;
  anchorDate: Date;
  onDatesChange: (period: CalendarPeriod, start: Date, end: Date) => void;
}

export const TaskCalendarToolbar: FC<TaskCalendarToolbarProps> = ({
  t,
  currentPeriod,
  anchorDate,
  onDatesChange,
}) => {
  const syncView = (viewType: string, start: Date, end: Date) => {
    onDatesChange(viewType as CalendarPeriod, start, end);
  };

  const handleViewDidMount = (arg: ViewMountArg) => {
    syncView(arg.view.type, arg.view.currentStart, arg.view.currentEnd);
  };

  const handleDatesSet = (arg: DatesSetArg) => {
    syncView(arg.view.type, arg.start, arg.end);
  };

  return (
    <div className="task-calendar-toolbar mb-3">
      <style>{`
        .task-calendar-toolbar .fc-view-harness {
          display: none !important;
        }
      `}</style>
      <FullCalendar
        plugins={CALENDAR_PLUGINS}
        initialView={currentPeriod}
        initialDate={anchorDate}
        firstDay={1}
        {...getCalendarToolbarOptions(t)}
        height="auto"
        events={[]}
        viewDidMount={handleViewDidMount}
        datesSet={handleDatesSet}
      />
    </div>
  );
};
